const LIST_API_URL = {
  EXPORT_CSV: "/ms/spm-disbursement/v2/bill/csv",
  EXPORT_CSV_PREVIEW: "/ms/spm-disbursement/v2/bill/csv/preview",
};

export const API_URL = {
  LIST: LIST_API_URL,
};
